// extracted by mini-css-extract-plugin
export var blue = "_1r-f";
export var brand = "_1r-b";
export var darkGrey = "_1r-e";
export var disabled = "_1r-4";
export var disabledSubtle = "_1r-5";
export var error = "_1r-6";
export var green = "_1r-g";
export var grey = "_1r-d";
export var icon = "_1r-0";
export var inherit = "_1r-a";
export var lightGrey = "_1r-c";
export var orange = "_1r-i";
export var pink = "_1r-k";
export var primary = "_1r-1";
export var purple = "_1r-l";
export var red = "_1r-j";
export var secondary = "_1r-2";
export var success = "_1r-9";
export var tertiary = "_1r-3";
export var warning = "_1r-7";
export var warningSecondary = "_1r-8";
export var white = "_1r-m";
export var yellow = "_1r-h";